import React from 'react';
import styled from 'styled-components';

const Wrap = styled.div`
  display: flex;
  align-items: center;

  a {
    color: #000;
  }
`;

const Input = styled.input`
  &,
  &[type='checkbox'] {
    appearance: none;
    width: 16px;
    height: 16px;
    min-width: 16px;
    position: relative;
    background: #eeeeee;
    border: 0;
    position: relative;
    margin-right: 15px;

    &:focus {
      background-color: #d4d4d4;
    }

    &:checked {
      background-color: #000;
    }

    &:focus:checked {
      background-color: #4d4d4d;
    }

    &:checked::after {
      content: '\\e914';
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: triumph;
      width: 16px;
      height: 16px;
      position: absolute;
      inset: 0;
      font-size: 14px;
      color: #fff;
    }
  }
`;

const Label = styled.label``;

const Checkbox = ({ children, body, id, ...props }) => (
  <Wrap>
    <Input id={id} type="checkbox" {...props} />
    <Label dangerouslySetInnerHTML={body} htmlFor={id}>
      {!body ? children : null}
    </Label>
  </Wrap>
);

export default Checkbox;
